import * as z from "zod";

// ============================================================
// USER
// ============================================================

// Simplified validation schema
export const SignupValidation = z.object({
  name: z.string().min(2, "Name must be at least 2 characters").max(50, "Name must be at most 50 characters"),
  username: z.string().min(6, "Username must be at least 6 characters"),
  emailOrPhone: z
    .string()
    .min(5)
    .max(50)
    .refine(
      (value) => {
        const isEmail = value.includes('@') && /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value);
        const isPhone = /^[0-9]{10,14}$/.test(value); // Only digits, without `+`
        return isEmail || isPhone;
      },
      {
        message: "Please enter a valid phone number",
      }
    ),
  password: z.string().min(12, "Password must be at least 12 characters"),
  acceptedSLA: z.boolean().default(false)
});

export const SignInValidation = z.object({
  emailOrPhone: z.string().min(5),
  password: z.string().min(8)
});


// Validation schema for verification
export const verificationSchema = z.object({
  code: z.string().min(4, 'Please enter the verification code')
});
export const OtpValidation = z.object({
  code: z.string().length(6)
});

export const ForgotPasswordValidation = z.object({
  emailOrPhone: z.string().min(5)
});

export const ResetPasswordValidation = z.object({
  password: z.string().min(6),
  confirmPassword: z.string().min(6)
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
});

export const ProfileValidation = z.object({
  file: z.custom<File[]>(),
  name: z.string().min(2, { message: "Name must be at least 2 characters." }),
  username: z.string().min(2, { message: "Name must be at least 2 characters." }),
  emailOrPhone: z
    .string()
    .min(5, { message: "Login ID is required." })
    .refine((value) => {
      const trimmed = value.trim();
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
      const isPhone = /^\+?\d{10,14}$/.test(trimmed);
      const isPhoneAlias = /^\+?\d{10,14}@busiconn\.com$/.test(trimmed);
      return isEmail || isPhone || isPhoneAlias;
    }, { message: "Invalid login ID" }),
  bio: z.string(),
});

// ============================================================
// POST
// ============================================================

export const PostValidation = z.object({
  individual: z.string().min(1, { message: "Please select your role" }),
  dealType: z.string().min(1, { message: "Please select your deal type" }),
  caption: z.string().min(5, { message: "Description must be at least 5 characters" }).max(2200, { message: "Description is too long" }),
  file: z.array(z.instanceof(File)).optional(),
  location: z.string().optional(),
  tags: z.string().optional(),
  isTrainingAvailable: z.boolean().optional(),
  isActivated: z.boolean().optional(),
  isSellingPost: z.boolean().optional()
});
